/*  ==============================================
//  Created by chuongnv                          ||
//===============================================*/
import { Component, Injectable, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, Message } from "primeng/primeng";
import { Location } from "@angular/common";
import { Subject } from "rxjs/Rx";
import { EvsStampService } from "../../../../common/services/EvsStamp.service";
import { PagerService } from "../../../../common/services/Pagination.service";
import { ModalInfoService } from "../../../../common/services/ModalInfo.service";
import { IOption } from "ng-select";
import { EvsErr } from "../evsErr";
import * as _ from "lodash";
import { NgForm } from "@angular/forms";

declare var $: any;

@Component({
  moduleId: module.id,
  selector: "evs-log-stamp-manage",
  templateUrl: "./log-stamp-manage.template.html",
  styleUrls: ["../../../../../css/fuck.css"],
  providers: [ConfirmationService, EvsStampService],
})
@Injectable()
export class LogStampActiveReleaseComponent implements OnInit {
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public currentPage: number = 1;
  public totalRow: number = 0;
  public page_size: number = 10;
  public pager: any = {};
  public stamp: any = [];
  public message: { class: string; content: string } = null;
  public error: string = "";
  public files: any = null;
  public componentData = null;
  public routerChange: any;
  public model: any = {};
  public modelStatus: any = {};
  public msgs: Message[] = [];
  public paramsQuery: any = {};
  public list_order: Array<IOption> = [];
  public order_value: any = "";
  public serial: any = "";
  list_store: Array<IOption> = [];
  public store_id: any = "";

  public current_filter: any = {};

  public item_active: any = 0;
  public item_detail: any = {};
  loading_data = true;
  page_title: string = "Lịch sử quản lý tem";

  listStatus = [
    { id: "active", name: "Kích hoạt" },
    { id: "deactive", name: "Hủy kích hoạt" },
    { id: "sample", name: "Xuất mẫu" },
    { id: "sold", name: "Xác thực / Đã bán" },
    { id: "restore", name: "Khóa" },
  ];

  log_active_status: number = 1;
  title: string = "Lịch sử kích hoạt tem";
  select_type_date_search: Array<IOption> = [
    { value: "created_at", label: "Ngày tạo" },
    { value: "active_at", label: "Ngày kích hoạt" },
    { value: "exp_product", label: "Hạn sử dụng" },
    { value: "exp_guarantee", label: "Hạn bảo hành" },
  ];
  list_stamp_service: any = [];

  constructor(
    private _location: Location,
    private router: Router,
    private stampService: EvsStampService,
    private pagerService: PagerService,
    private mdInfo: ModalInfoService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    // this.clearDataForm();
    this.getListOrder();
    this.getListStore();
    this.getListStampService();
    $(".input-daterange").datepicker({
      format: "dd-mm-yyyy",
      // "setDate": new Date(),
    });

    $("#status").select2({
      placeholder: "-- Chọn trạng thái --",
      allowClear: true,
    });
    $("#select-order-id").select2({
      placeholder: "-- Chọn lô tem --",
      allowClear: true,
    });
    $("#store_id").select2({
      placeholder: "-- Chọn cửa hàng --",
      allowClear: true,
    });

    // this.getInfoStamps();
    // this.routerChange = this.activatedRoute.queryParams.subscribe((params: Params) => {
    //     this.paramsQuery = {
    //         // page: params['page'],
    //         // page_size: this.page_size,
    //         status: params['status'],
    //         from: params['from'],
    //         to: params['to'],
    //         order_id: params['order_id'],
    //         store_id: params['store_id'],
    //         count_id: params['count_id'],
    //     };
    //     for (var propName in this.paramsQuery) {
    //         if (this.paramsQuery[propName] === null || this.paramsQuery[propName] === undefined || this.paramsQuery[propName] === "") {
    //             delete this.paramsQuery[propName];
    //         }
    //     }
    //     this.loadData(this.paramsQuery);
    // });
    // this.modelStatus.status = 'active';

    this.loadData();
  }

  // getInfoStamps() {
  //     this.stampService.getInfoStamps().toPromise().then(res => {
  //         this.stampInfo = res.data;
  //     }, err => {
  //         this.message = {
  //             class: "alert dark alert-danger",
  //             content: 'Stamp statistic: ' + err.message
  //         };
  //     });
  // }

  getListStampService() {
    this.stampService
      .listStampService()
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let listService: any = [];
          for (let _data of res.data) {
            listService[_data.id] = _data.name;
          }
          this.list_stamp_service = listService;
        } else {
          EvsErr.evs_err(res, false);
        }
      })
      .catch((err: any) => {
        EvsErr.evs_err(err);
      });
  }

  convertServiceToText(service_: string = "") {
    if (service_) {
      let text = "";
      let service_convert: Array<{ text: string; badge_class: string }> = [];
      let arr_service = service_.split(",");
      let all_service = this.list_stamp_service;
      let class_arr = [
        "success",
        "info",
        "primary",
        "warning",
        "default",
        "danger",
      ];
      let i = 0;
      for (let s of arr_service) {
        if (all_service[s]) {
          service_convert.push({
            text: all_service[s],
            badge_class: class_arr[i],
          });
          text += text
            ? ', <span class="badge badge-' +
              class_arr[i] +
              '">' +
              all_service[s] +
              "</span>"
            : '<span class="badge badge-' +
              class_arr[i] +
              '">' +
              all_service[s] +
              "</span>";
        }
        i++;
      }
      return service_convert;
    }
    return false; // không xác định
  }

  loadData(request: any = {}) {
    this.loading_data = true;

    let data_get: any = _.isEmpty(request) ? this.current_filter : request;

    if (this.currentPage < 0) {
      this.currentPage = 1;
    }
    data_get.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    data_get.limit = this.page_size;
    data_get.desc = "created_time";

    // let data_get:any = datafilter.length>0 ? datafilter : this.current_filter;
    //
    // if(this.currentPage<0){
    //     this.currentPage = 1;
    // }
    // data_get.offset = this.page_size * (this.currentPage<=0 ? 0 : this.currentPage-1);
    // data_get.limit = this.page_size;
    // data_get.desc = 'created_time';
    this.stampService
      .getLogsActiveRelease(data_get)
      .toPromise()
      .then((res: any) => {
        this.loading_data = false;
        // console.log(res);
        if (res.status == 200 && res.error == false) {
          this.totalRow = res.data.total;

          let list_stamp_: any = [];
          for (let data_ of res.data.logs) {
            let prefix =
              data_.order && data_.order.prefix ? data_.order.prefix : "";
            if (data_.list.length > 0) {
              data_.list_ = this.formatListSerial(data_.list, prefix);
            } else {
              data_.start_ = this.formatSerial(data_.start, prefix);
              data_.end_ = this.formatSerial(data_.end, prefix);
            }
            if (data_.order && data_.order.stamp_service) {
              data_.stamp_service_ = this.convertServiceToText(
                data_.order.stamp_service
              );
            }
            list_stamp_.push(data_);
          }
          this.stamp = list_stamp_;
          this.item_detail = null;
          if (this.stamp.length > 0) {
            this.item_detail = this.stamp[0];
            this.item_active = 0;
            // console.log(this.item_detail);
          }

          this.setPage(this.currentPage);
        } else {
          console.log("false");
        }
      })
      .catch((err: any) => {
        EvsErr.evs_err(err);
      });
  }

  viewDetail(i) {
    this.item_active = i;
    this.item_detail = this.stamp[i];
  }

  onSubmit() {
    let params: any = {};
    let start = $("#inputStart").val();
    // console.log(start);
    if (start) {
      let ar_start = start.split("-");
      let d = new Date(
        parseInt(ar_start[2]),
        parseInt(ar_start[1]) - 1,
        parseInt(ar_start[0]),
        0,
        0,
        0
      );
      params.from = d.getTime() / 1000;
      // params.from = parseInt(moment(start, "DD-MM-YYYY HH:mm:ss").format('x')) / 1000 + 86400;
    }

    let end = $("#inputEnd").val();
    if (end) {
      let ar_end = end.split("-");
      let d = new Date(
        parseInt(ar_end[2]),
        parseInt(ar_end[1]) - 1,
        parseInt(ar_end[0]),
        23,
        59,
        59
      );
      params.to = d.getTime() / 1000;
      // params.to = parseInt(moment(end, "DD-MM-YYYY HH:mm:ss").format('x')) / 1000 + 86400;
    }

    if (this.serial) {
      params.count_id = this.serialToNumber(this.serial);
    }
    // console.log(this.store_id);
    let selected_order = $("#select-order-id").val();
    if (selected_order) {
      // console.log(this.order_value);
      params.order_id = selected_order;
    }

    if (this.store_id) {
      params.store_id = this.store_id;
    }

    let select_status = $("#status").val();
    if (select_status) {
      params.status = select_status;
    }

    // console.log(params);
    this.current_filter = params;
    this.currentPage = 1;
    this.loadData(params);
    // console.log('this.model',this.model);
    // this.router.navigate([], {
    //     queryParams: params
    // });
  }

  getListOrder() {
    this.stampService
      .listOrder({ status: 3, is_deleted: 0, limit: 500, desc: "id" })
      .toPromise()
      .then((res: any) => {
        // console.log('order',res);
        if (res.error == false) {
          let listO = [];
          for (let item of res.data.orders) {
            let obj = {
              value: item.id,
              label: item.name,
            };
            listO.push(obj);
          }
          this.list_order = listO;
        } else {
          EvsErr.evs_err(res, false);
        }
      })
      .catch((err: any) => {
        EvsErr.evs_err(err);
      });
  }

  getListStore() {
    this.stampService
      .getAllStore({ desc: "id", status: 1, limit: 500 })
      .toPromise()
      .then((res: any) => {
        if (res.status == 200) {
          let all_store = [];
          for (let p of res.data.store) {
            all_store.push({ value: p.id, label: p.name });
          }
          this.list_store = all_store;
        } else if (res.status == 400) {
          this.message.class = "warning";
          this.message.content = res.message;
        } else {
          EvsErr.evs_err(res, false);
        }
      })
      .catch((err: any) => {
        EvsErr.evs_err(err);
      });
  }

  setPage(page: number) {
    if (page < 1) {
      this.currentPage = 1;
      return;
    }
    this.pager = this.pagerService.getPager(
      this.totalRow,
      this.currentPage,
      this.page_size
    );
    if (page != this.currentPage) {
      this.currentPage = page;
      this.loadData();
    }
  }

  formatBatchSerial(start: any, end: any, order: any) {
    if (!start || !end) {
      start = order.id_start;
      end = order.id_end;
    }
    // console.log(order);
    let prefix = order && order.prefix ? order.prefix : "";
    return (
      this.formatSerial(start, prefix) + "đến" + this.formatSerial(end, prefix)
    );
  }

  formatListSerial(list, prefix: string = "") {
    // console.log(list, prefix);
    let list_serial = [];
    if (list) {
      for (let serial of list) {
        list_serial.push(this.formatSerial(serial, prefix));
      }
    }
    return list_serial;
  }

  formatSerial(serial, prefix: string = "") {
    let format_serial: string = "";
    if (serial) {
      let prefix2 = prefix ? prefix + "-" : "";
      serial = serial.toString();
      if (serial.length > 6) {
        format_serial = prefix2 + serial;
      } else {
        let pad = "000000";
        format_serial = prefix2 + pad.substring(0, 6 - serial.length) + serial;
      }
    }
    return format_serial;
  }

  // public Serial(id_end, id_start, prefix) {
  //     id_end = id_end.toString();
  //     id_start = id_start.toString();
  //     let serial = 'Chưa thanh toán';
  //     if (id_end && id_start && prefix) {
  //         let pad = "000000";
  //         let serial_start = pad.substring(0, 6 - id_start.length) + id_start;
  //         let serial_end = pad.substring(0, 6 - id_end.length) + id_end;
  //         serial = prefix + serial_start + ' - ' + prefix + serial_end;
  //     }
  //     return serial;
  // }

  serialToNumber(serial) {
    let _serial = serial.split("-");
    if (_serial.length == 1) {
      return parseInt(_serial[0]) ? parseInt(_serial[0]) : 0;
    } else {
      return parseInt(_serial[_serial.length - 1])
        ? parseInt(_serial[_serial.length - 1])
        : 0;
    }
  }

  resetForm(frm: NgForm) {
    $("#service").val("").trigger("change");
    $("#type").val("").trigger("change");
    $("#select-order-id").val("").trigger("change");
    $("#status").val("").trigger("change");
    frm.reset();
    $("#type").val("create_time");
    this.onSubmit();
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp/log-stamp-active-release.component.ts